const getEasternDateInput = value => {
  if (!value || !Number.isFinite(new Date(value).getTime())) return '';
  return getEasternDateTimeInput(value).slice(0, 10);
};

const getEarliestTerminationDate = (now = new Date()) => {
  const day = new Date(`${getEasternDateInput(now)}T00:00:00Z`);
  day.setUTCDate(day.getUTCDate() + 3);
  return day.toISOString().slice(0, 10);
};

const getDateBoundary = (day, isEnd = false) => {
  if (typeof day !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const local = new Date(`${day}T${isEnd ? '23:59' : '00:00'}:00Z`);
  if (!Number.isFinite(local.getTime()) || local.toISOString().slice(0, 10) !== day) return null;
  const correctOffset = instant => instant + local.getTime() - new Date(`${getEasternDateTimeInput(instant)}Z`).getTime();
  const instant = correctOffset(correctOffset(local.getTime()));
  return new Date(instant).toISOString();
};

const getEasternDateTimeInput = value => {
  const parts = dateTimeFormatter.formatToParts(new Date(value));
  const get = type => parts.find(part => part.type === type).value;
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`;
};
const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

module.exports = { getEasternDateInput, getDateBoundary, getEarliestTerminationDate };
